import { set } from 'cerebral/operators'

export default [set('state:app.listUserHeaderAccessMenuOpen', false)]



// WEBPACK FOOTER //
// ./src/modules/app/chains/closeListUserHeaderAccessMenu.js